import React from "react";
import { Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import pathnames from "../../../constants/pathnames";
import { Edit, FileDownloadOutlined } from "@mui/icons-material";
import EmptyState from "../../../lib/components/EmptyState";
import { moneyFormat } from "../../../utils/moneyFormat";

const InvoicesDataTable = ({ data, isLoading, onEditPayment }) => {
  const navigate = useNavigate();
  if (isLoading) return null;
  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead className="bg-light">
            <TableRow>
              <TableCell>Invoice Number</TableCell>
              <TableCell>Billing Date</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Plan</TableCell>
              <TableCell>Period</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((item) => (
              <TableRow key={item?.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell>{item?.number}</TableCell>
                <TableCell>{moment(item?.paidAt).format("Do MMM, YYYY")}</TableCell>
                <TableCell>{moneyFormat(item?.amount ?? 0)}</TableCell>
                <TableCell>
                  <Status status={item?.status} />
                </TableCell>
                <TableCell>{item?.subscriptionMeta?.planName}</TableCell>
                <TableCell>{item?.subscriptionMeta?.billingInterval}</TableCell>
                <TableCell>
                  <span className="d-flex align-items-center gap-3">
                    <IconButton size="small" color="secondary" onClick={() => navigate(`${pathnames.ORGANIZATIONS_INVOICES}/${item?.id}`)}>
                      <FileDownloadOutlined />
                    </IconButton>
                    <IconButton size="small" color="secondary" onClick={() => onEditPayment(item)}>
                      <Edit />
                    </IconButton>
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <EmptyState isEmpty={!isLoading && !data?.length} />
    </Paper>
  );
};

function Status({ status }) {
  if (status === "PAID") return <div className="badge rounded-pill  fw-medium fs-sm bg-success text-success bg-opacity-25">Active</div>;
  if (status === "EXPIRED") return <div className="badge bg-warning text-warning rounded-pill fw-medium fs-sm bg-opacity-25">Expired</div>;
  return null;
}

export default InvoicesDataTable;
